import CustomLayoutGeneralSettings from '@/components/CustomLayoutGeneralSettings';
import { DataCalculationMethodEnum } from '@/constants/enum';
import settingsSlice, { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { BlockStack, RadioButton } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';

const CalculationDeliveryMethod = () => {
  const dispatch = useDispatch();
  const dataSettings = useSelector(dataSettingsSelector);
  const handleChange = (value: DataCalculationMethodEnum) => {
    dispatch(
      settingsSlice.actions.handleDataSettings({
        ...dataSettings,
        dateCalculationMethod: value,
      }),
    );
  };

  return (
    <CustomLayoutGeneralSettings
      title="Delivery date calculation method"
      description="Set how minimum and maximum estimated delivery date is calculated from"
    >
      <div className="d-flex flex-column mt-4">
        <p className="mb-4">Estimated delivery date is calculated from</p>

        <BlockStack>
          <RadioButton
            label="Order date"
            helpText="Delivery date = Order date + Number of delivery days"
            checked={dataSettings?.dateCalculationMethod === DataCalculationMethodEnum.OrderDate}
            id={DataCalculationMethodEnum.OrderDate}
            name="dateCalculationMethod"
            onChange={() => {
              handleChange(DataCalculationMethodEnum.OrderDate);
            }}
          />
          <RadioButton
            label="Max preparation date"
            helpText="Delivery date = Order date + Max preparation date + Number of delivery days"
            checked={dataSettings?.dateCalculationMethod === DataCalculationMethodEnum.MaxPreparationDate}
            id={DataCalculationMethodEnum.MaxPreparationDate}
            name="dateCalculationMethod"
            onChange={() => {
              handleChange(DataCalculationMethodEnum.MaxPreparationDate);
            }}
          />
        </BlockStack>
      </div>
    </CustomLayoutGeneralSettings>
  );
};

export default CalculationDeliveryMethod;
